import moment from "moment";
import { Tooltip } from "bootstrap";
import i18next from "i18next";

export const comapanyNameToClass = (companyName) => {
  switch (companyName) {
    case "AGAP2":
      return "agap";
    case "AGAP2NL":
      return "agap";
    case "Decode":
      return "decode";
    case "KCS":
      return "kcsit";
    case "Adentis":
      return "adentis";
    case "Bee":
      return "bee";
    case "TeamIT":
      return "team-it";
    case "Sowin":
      return "sowin";
    case "RECODME":
      return "recodme";
    case "Codewin":
      return "codewin";
    case "GMS":
      return "GMS";
    case "ATS4IT":
      return "ats4it";
    case "AGAP2IND":
      return "agap2ind";
    default:
      return "moongy";
  }
};

export const ordinalSuffix = (number) => {
  if (number % 10 === 1) {
    return i18next.t("st.");
  } else if (number % 10 === 2) {
    return i18next.t("nd.");
  } else if (number % 10 === 3) {
    return i18next.t("rd.");
  } else {
    return i18next.t("th.");
  }
};

export const handleDateKeyUp = (e) => {
  e.currentTarget.maxLength = 10;
  let keyInput = e.currentTarget.value;

  keyInput = keyInput.replace(/\D/g, "");
  keyInput = keyInput.replace(/(^\d{2})(\d)/, "$1-$2");
  keyInput = keyInput.replace(/(\d{2})(\d)/, "$1-$2");

  e.currentTarget.value = keyInput;
  return e;
};

export function FormatDateToDateTime(date) {
  if (date == null) {
    return "";
  } else {
    return new Date(date).toLocaleString();
  }
}

export function toDateString(date) {
  if (!moment(date).isValid()) return;
  let _date = new Date(date);
  let day =
    _date.getDate().toString().length > 1
      ? _date.getDate()
      : `0${_date.getDate()}`;
  let month =
    (_date.getMonth() + 1).toString().length > 1
      ? _date.getMonth() + 1
      : `0${_date.getMonth() + 1}`;

  return `${day}-${month}-${_date.getFullYear()}`;
}

export function ToDateTimeString(date) {
  if (!moment(date).isValid()) return;
  let _date = new Date(date);
  let day =
    _date.getDate().toString().length > 1
      ? _date.getDate()
      : `0${_date.getDate()}`;
  let month =
    (_date.getMonth() + 1).toString().length > 1
      ? _date.getMonth() + 1
      : `0${_date.getMonth() + 1}`;
  let hours =
    _date.getHours().toString().length > 1
      ? _date.getHours()
      : `0${_date.getHours()}`;

  let minutes =
    _date.getMinutes().toString().length > 1
      ? _date.getMinutes()
      : `0${_date.getMinutes()}`;
  return `${day}-${month}-${_date.getFullYear()} ${hours}:${minutes}`;
}

export function blockRetroactiveDates(date) {
  let yesterday = moment().subtract(1, "day");

  return date.isAfter(yesterday);
}

function checkifIsDate(field) {
  if (moment(field).isValid()) {
    return true;
  } else {
    return false;
  }
}

export function translateAndSortAscendant(list, field) {
  let _list = [...list];
  _list.forEach((x) => (x[field] = i18next.t(x[field])));
  _list.sort((a, b) => {
    if (Object.prototype.toString.call(field) === "[object Date]")
      return a[field] > b[field] ? 1 : -1;
    else if (checkifIsDate(a[field]))
      return new Date(a[field]) > new Date(b[field]) ? 1 : -1;
    else return a[field] > b[field] ? 1 : -1;
  });
  return _list;
}

export function translateAndSortDescendant(list, field) {
  let _list = [...list];
  _list.forEach((x) => (x[field] = i18next.t(x[field])));
  _list.sort((a, b) => {
    if (Object.prototype.toString.call(field) === "[object Date]")
      return a[field] > b[field] ? -1 : 1;
    else if (checkifIsDate(a[field]))
      return new Date(a[field]) > new Date(b[field]) ? -1 : 1;
    else return a[field] > b[field] ? -1 : 1;
  });
  return _list;
}

export function loadTooltips() {
  var tooltipTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="tooltip"]')
  );
  tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new Tooltip(tooltipTriggerEl);
  });
}

export function serializeObject(object) {
  let serialized = "";

  for (let key in object) {
    if (object[key] || object[key] === 0)
      if (moment.isDate(object[key]))
        serialized = `${serialized}${key}=${object[key].toUTCString()}&`;
      else
        serialized = `${serialized}${key}=${encodeURIComponent(object[key])}&`;
  }
  return serialized;
}

export function validatePhoneNumber(phoneNumber, numberMaxOfCharacters) {
  let error = {
    format: false,
    maxLength: false,
    maxNum: numberMaxOfCharacters
  };

  if (phoneNumber && phoneNumber !== "") {
    let phoneNumberPatern = /\+\d{1,3}.+\d{9}|\+\d{10,12}|^\d{9}$|\(\+\d{1,3}\)\s+\d{3}\s+\d{3}\s+\d{3}|\+\d{1,3}\s+\d{3}\s+\d{3}\s+\d{3}|\d{10,12}/;

    if (!phoneNumberPatern.test(phoneNumber)) {
      error.format = true;
    }

    if (phoneNumber.length > numberMaxOfCharacters) {
      error.maxLength = true;
    }

    if (phoneNumber.match(" ")) {
      error.format = false;
    }
  }

  return error;
}

export const QueryString = {
  saveJsonObject(object, key) {
    let stringSearchobject = JSON.stringify(object);
    let urlWithSearchParams = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${key}=${stringSearchobject}`;

    window.history.pushState({ path: "" }, "", urlWithSearchParams);
  },

  getJsonObject(key) {
    const urlParams = new URLSearchParams(window.location.search);
    const urlSearchObjectParams = Object.fromEntries(urlParams.entries());
    if (urlSearchObjectParams[key])
      return JSON.parse(urlSearchObjectParams[key]);
  },

  getUrlParameter(key) {
    const urlParams = new URLSearchParams(window.location.search);
    const urlSearchObjectParams = Object.fromEntries(urlParams.entries());
    return urlSearchObjectParams[key];
  }
};

export function isValidEmail(email) {
  const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailPattern.test(email);
}
